import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';

class AgentConversationList extends Component {

    render() {
        let agents = this.props.agentsList || [];
        return (
                <div className="s360-landing-page-header-agent-info-contianer">
                    {agents.map((agentInfo, index) => 
                       <AgentDetail key={"agent-cell-container-" + index} agentInfo={agentInfo} {...this.props} />
                    )}
                </div>
        )
    }

}

class AgentDetail extends Component {

    render() {
        let agentName      = (this.props.agentInfo && this.props.agentInfo.shortName) || "";
        let placeholderPic = "https://hummingwave-image-util.s3.amazonaws.com/agent-3x.png";
        let profilePic     = (this.props.agentInfo && this.props.agentInfo.userProfilePic) || placeholderPic;
        return (
            <div className="s360-landing-page-header-agent-info-cell">
                {/* <div className="s360-landing-page-header-agent-info"> */}
                    <div className="s360-landing-page-header-agent-img">
                        <img style={{background:"white"}} src={profilePic}
                        width ="50px"
                        height= "50px" />
                    </div>
                    <div className="s360-conversation-header-agent-ping-status-container"><div className="s360-agents-list-header-agent-ping-status" style={{ backgroundColor: "#00FF00"}} ></div></div>
                    <div className="s360-landing-page-header-agent-name" >
                        {agentName}
                    </div>
                {/* </div> */}
            </div>
        )
    }
}

export default AgentConversationList;